
import { Box, Grid } from '@mui/material';

import AccountDelete from './AccountDelete';

function AccountActions() {
  return (
    <Box width='100%' padding='15px'>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box
            padding='15px'
            sx={{
              maxWidth: 600,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <AccountDelete />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AccountActions;

